import React, { useCallback, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { UncontrolledDropdownWrapper } from './UncontrolledDropdown.elements'

// Utils
import { useOutsideAlerter } from 'common/utils/outsideAlerter'

// Context
import { DropdownContext } from '../DropdownContext'

function UncontrolledDropdown(props) {
  // Destructure
  const { children, direction, ...rest } = props

  // Local State
  const [isOpen, setIsOpen] = useState(false)
  const toggle = useCallback(() => setIsOpen((prevValue) => !prevValue), [])
  const close = useCallback(() => setIsOpen(false), [])

  const contextValue = useMemo(
    () => ({
      isOpen,
      toggle,
      close,
      direction,
    }),
    [isOpen, toggle, close, direction]
  )

  // Refs
  const btnRef = useRef()

  // utils
  useOutsideAlerter(btnRef, close)
  return (
    <DropdownContext.Provider value={contextValue}>
      <UncontrolledDropdownWrapper direction={direction} {...rest} ref={btnRef}>
        {children}
      </UncontrolledDropdownWrapper>
    </DropdownContext.Provider>
  )
}

// Default Props
UncontrolledDropdown.defaultProps = {
  children: '',
  direction: '',
}

// Proptypes Validation
UncontrolledDropdown.propTypes = {
  direction: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default UncontrolledDropdown
